import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import PackingKiosk from './pages/PackingKiosk';
import { isConnected } from './services/api';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import NewOrder from './pages/NewOrder';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Warehouse from './pages/Warehouse';
import Packing from './pages/Packing';
import Shipping from './pages/Shipping';
import Invoices from './pages/Invoices';
import Payments from './pages/Payments';
import FacebookPublish from './pages/FacebookPublish';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Customers from './pages/Customers';

export default function App() {
  const [connected, setConnected] = useState(isConnected());

  return (
    <BrowserRouter>
      <Routes>
        {/* Standalone kiosk — no sidebar, PIN protected */}
        <Route path="/balirna" element={<PackingKiosk />} />

        {/* Login */}
        <Route path="/login" element={
          connected ? <Navigate to="/dashboard" replace /> : <Login onLogin={() => setConnected(true)} />
        } />

        <Route path="/" element={connected ? <Layout /> : <Navigate to="/login" replace />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/new" element={<NewOrder />} />
          <Route path="orders/:id" element={<OrderDetail />} />
          <Route path="products" element={<Products />} />
          <Route path="products/:id" element={<ProductDetail />} />
          <Route path="warehouse" element={<Warehouse />} />
          <Route path="packing" element={<Packing />} />
          <Route path="shipping" element={<Shipping />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="payments" element={<Payments />} />
          <Route path="facebook" element={<FacebookPublish />} />
          <Route path="reports" element={<Reports />} />
          <Route path="customers" element={<Customers />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
